<template>
  <div>
    <h3>分类管理</h3>

    <!-- 查询 + 选择 APP 区域 -->
    <el-row :gutter="10" style="margin-bottom:15px;">
      <el-col :span="6">
        <el-select v-model="queryAppId" clearable filterable placeholder="选择APP ID" style="width:100%">
          <el-option label="全部APP" value=""></el-option>
          <el-option v-for="item in appList" :key="item.appId" :label="item.appId" :value="item.appId"></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-input v-model="searchName" clearable placeholder="搜索分类名称"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="getList">查询</el-button>
      </el-col>
      <el-col :span="8">
        <el-button type="success" @click="addShow = true">新增分类</el-button>
      </el-col>
    </el-row>

    <!-- 分类列表 -->
    <el-table :data="list" border style="width:100%;">
      <el-table-column prop="appId" label="APP ID" />
      <el-table-column prop="name" label="分类名称" />
      <el-table-column prop="sort" label="排序" />
      <el-table-column label="操作">
        <template #default="{row}">
          <el-button @click="openEdit(row)">修改</el-button>
          <el-button type="danger" @click="del(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      :current-page="pageNum"
      :page-size="pageSize"
      :total="total"
      style="margin-top:20px;text-align:right;"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="getList"
      @current-change="getList"
    />

    <!-- 新增弹窗 -->
    <el-dialog title="新增分类" :visible.sync="addShow">
      <el-form :model="form">
        <el-form-item label="APP ID">
          <el-select v-model="form.appId" filterable placeholder="请选择APP" style="width:100%">
            <el-option v-for="item in appList" :key="item.appId" :label="item.appId" :value="item.appId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称">
          <el-input v-model="form.name" placeholder="请输入分类名称" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addShow = false">取消</el-button>
        <el-button type="primary" @click="add">确定</el-button>
      </div>
    </el-dialog>

    <!-- 修改弹窗 -->
    <el-dialog title="修改分类" :visible.sync="editShow">
      <el-form :model="form">
        <el-form-item label="分类名称">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editShow = false">取消</el-button>
        <el-button type="primary" @click="edit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import req from '@/api/request'
export default {
  data() {
    return {
      appList: [],
      list: [],
      total: 0,         // 总数
      pageNum: 1,       // 当前页
      pageSize: 10,     // 每页条数
      queryAppId: '',
      searchName: '',
      addShow: false,
      editShow: false,
      form: {
        id: '',
        appId: '',
        name: '',
        sort: 0
      }
    }
  },
  mounted() {
    this.loadAppList()
    this.getList()
  },
  methods: {
    async loadAppList() {
      const res = await req.get('/admin/app/list')
      this.appList = res.data || []
    },
    async getList() {
      const res = await req.get('/admin/category/list', {
        params: {
          appId: this.queryAppId,
          name: this.searchName,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      })
      this.list = res.data?.list || []
      this.total = res.data?.total || 0
    },
    async add() {
      await req.post('/admin/category/add', this.form)
      this.$message.success('新增成功')
      this.addShow = false
      this.getList()
    },
    openEdit(row) {
      this.form = { ...row }
      this.editShow = true
    },
    async edit() {
      await req.post('/admin/category/edit', this.form)
      this.$message.success('修改成功')
      this.editShow = false
      this.getList()
    },
    async del(id) {
      await req.post('/admin/category/del', { id })
      this.$message.success('删除成功')
      this.getList()
    }
  }
}
</script>